import { FC } from 'react'
import { twMerge } from 'tailwind-merge'

interface Props {
  className?: string
  text: string
}

const Title: FC<Props> = ({ text, className }) => (
  <h1 className={twMerge('text-6xl md:text-8xl font-bold', className)}>
    {text}
  </h1>
)

export default Title
